export default "__VITE_ASSET__0c0351d1__"